/**
 * Pickup / collect flow scope (IMP-06, GC-P1-04).
 */
import { createContext, useContext, useMemo, type ReactNode } from 'react';

export interface PickupScope {
  readonly transactionId: number | null;
  readonly pickupPointId: number | null;
}

const PickupContext = createContext<PickupScope | null>(null);

export function PickupProvider({
  scope,
  children,
}: {
  readonly scope: PickupScope;
  readonly children: ReactNode;
}): JSX.Element {
  const value = useMemo(() => scope, [scope]);
  return <PickupContext.Provider value={value}>{children}</PickupContext.Provider>;
}

export function usePickupScope(): PickupScope | null {
  return useContext(PickupContext);
}
